interface BannerContentProps {
  icon?: string;
  iconAlt?: string;
  title: string | React.ReactNode;
  description?: string;
  className?: string;
  iconClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  showIcon?: boolean;
}

const BannerContent: React.FC<BannerContentProps> = ({
  icon,
  iconAlt = 'Page icon',
  title,
  description,
  className = '',
  iconClassName = '',
  titleClassName = '',
  descriptionClassName = '',
  showIcon = true,
}) => {
  return (
    <div className={`mb-12 mt-[10vw] text-center ${className}`}>
      {showIcon && icon && (
        <img
          src={icon}
          alt={iconAlt}
          className={`relative mx-auto mb-10 size-[10vw] md:size-[8vw] lg:size-[5vw] ${iconClassName}`}
        />
      )}

      <h1
        className={`mb-6 text-4xl font-bold md:text-5xl lg:text-7xl ${titleClassName} whitespace-pre-line`}
      >
        {title}
      </h1>

      {description && (
        <p
          className={`mx-auto max-w-sm text-xl text-gray-300 md:max-w-xl lg:max-w-3xl ${descriptionClassName}`}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default BannerContent;
